module.exports = __webpack_public_path__ + "static/media/icon_playstore.35551986.svg";